// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#favorite-tab[data-v-ed53895c]{padding:0 10px 0 10px}`, "",{"version":3,"sources":["webpack://./src/components/FavoriteSidebarTab.vue"],"names":[],"mappings":"AACA,+BACC,qBAAA","sourcesContent":["\n#favorite-tab {\n\tpadding: 0 10px 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
